<template>
  <Base>
    <template v-slot:toolbar>
      <div id="kt_toolbar" class="toolbar">
        <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    Tableau de bord
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>


          <div class="d-flex align-items-center py-1">
            <router-link :to="{ name: 'form-list', params: { slug: $route.params.slug } }"
                         class="btn-sm btn-primary btn">
              <i class="fad fa-ballot-check text-white"></i>
              {{ trans('Formulaires') }}
            </router-link>

            <button class="btn btn-warning btn-sm ms-3" @click="generate">
              <i class="fad fa-cogs"></i>
              {{ trans('Generate') }}
            </button>

            <button v-if="hasRole('SUPER_ADMIN')" class="btn btn-danger btn-sm ms-3" @click="cleanOrphanProperties">
              <i class="fad fa-trash"></i>
              {{ trans('Clean Oprhan Properties') }}
            </button>

          </div>

        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="">
        <div class="title">
          <template v-if="branch">{{ trans(branch.TitleMixin) }}</template>
          {{ trans('Configuration') }}
        </div>
        <div v-if="loading" class="mw-500px m-auto">
          <Loading></Loading>
        </div>
        <!--                                <div class="d-flex flex-wrap">-->

        <draggable :animation="200" :list="itemTypes" class="d-flex flex-wrap" filter=".action-button" ghost-class="bg-light-primary" group="required" tag="div" @end="updateItemRanks">
          <template v-for="item in itemTypes">
            <div v-if="item.required" class="card m-3 card-xxl-stretch mb-xl-3 flex-grow-1 mw-400px">
              <div class="card-header border-0">
                <div>
                  <h3 class="card-title fw-bolder text-dark">
                    <i :class="item.icon + ' me-2'"></i>
                    {{ trans(item.name) }}
                  </h3>
                  {{ item.code }} ▪ {{ item.className }}
                </div>
                <div class="card-toolbar">
                  <b-dropdown ref="filter" no-caret no-flip right size="sm" style="padding:0" tag="div"
                              toggle-class="topbar-item text-decoration-none" variant="link">
                    <template v-slot:button-content>
                      <div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                        <i class="fad fa-th-large "></i>
                      </div>
                    </template>
                    <b-dropdown-text class="p-0 b-dropdown-text" tag="div">
                      <div class="p-0">
                        <div class="d-flex row dropmenu bg-white">
                          <a v-if="hasRole('ROLE_ADMIN')" v-b-modal.modal-1
                             class="dropdown-item cursor-pointer" @click="setItem(item)">
                            {{ trans('Edit') }}
                          </a>
                          <a v-b-modal.modal-2 class="dropdown-item cursor-pointer"
                             @click="addProperty(item)">
                            {{ trans('Add_property') }}
                          </a>
                          <a class="dropdown-item cursor-pointer" @click="deleteItem(item.uuid)">
                            {{ trans('Delete') }}
                          </a>
                        </div>
                      </div>
                    </b-dropdown-text>
                  </b-dropdown>
                </div>
              </div>
              <div class="card-body pt-2">
                <draggable :animation="200" :group="item.uuid" :list="item.properties" filter=".action-button" ghost-class="bg-light-primary" tag="div" @end="updatePropertyRanks(item)">
                  <div v-for="property in item.properties" class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <i v-if="property.required" class="fas fa-asterisk text-danger"></i>
                          <span class="text-gray-800 text-hover-primary fw-bolder fs-6" href="#">
                            {{ trans(property.name) }}
                            <span v-if="property.link" class="text-muted ms-2">
                              <i class="fad fa-link"></i>
                              {{ property.link }}
                            </span>
                          </span>
                          <span v-if="property.type && property.type.code === 'OBJECT'" class="text-muted fw-bold d-block">{{ trans(property.type.label) }} ◾ {{ trans(property.value) }}
                          </span>
                          <span v-else class="text-muted fw-bold d-block">
                            {{ trans(property.type.label) }} ◾
                            <template v-if="property.type && property.type.code === 'BOOLEAN'">
                              {{ Boolean(Number(property.value)) ? trans('true') : trans('false') }}
                            </template>
                            <template v-else>
                              {{ trans(property.value) }}
                            </template>
                          </span>
                        </div>
                        <div class="ms-5">
                          <i v-if="!property.internal || hasRole('ROLE_ADMIN')"
                             v-b-tooltip.hover
                             :class="property.isAlias ? 'text-primary' : 'text-gray-400'"
                             :title="'intégré dans l\'alias'" class="fad fa-eye cursor-pointer"
                             @click.prevent.stop="toggleAlias(property)"></i>
                          <i v-if="!property.internal || hasRole('ROLE_ADMIN')"
                             v-b-modal.modal-2 class="fad fa-edit cursor-pointer ms-2"
                             @click="editProperty(property, item)"></i>
                          <i v-b-tooltip.hover
                             :class="property.identifier ? 'text-primary' : 'text-gray-400'"
                             :title="trans('is_an_identifier')"
                             class="fad fa-crosshairs cursor-pointer ms-2" @click.prevent.stop="toggleIdentifier(property)"></i>
                          <i v-if="!property.internal || hasRole('ROLE_ADMIN')"
                             class="fad fa-trash text-danger ms-2 cursor-pointer"
                             @click="removeProperty(property)"></i>
                          <!--                                            <i :class=" property.required ? 'text-danger'  : 'text-gray-400'"-->
                          <!--                                               :title="trans('is_required')" @click.prevent.stop="toggleRequired(property)"-->
                          <!--                                               class="fad fa-exclamation-triangle ms-2  cursor-pointer"-->
                          <!--                                               v-b-tooltip.hover></i>-->
                        </div>
                      </div>
                    </div>
                    <!--                                <span class="badge badge-light-success fs-8 fw-bolder">New</span>-->
                  </div>
                </draggable>
              </div>
              <div v-if="item.branch" class="card-footer justify-content-center py-2 d-flex">

                <div class="signature">
                  <div v-if="item.updateBy" class="user text-primary cursor-pointer">
                    {{ item.updateBy }}
                  </div>
                  <div class="date">
                    {{ readableDate(item.updatedAt) }}
                  </div>

                </div>
                <!--                            <div class="btn btn-primary btn-sm">-->
                <!--                                <i class="fad fa-plus"></i>-->
                <!--                                {{trans('Add_property')}}-->
                <!--                            </div>-->
              </div>
            </div>
          </template>
        </draggable>


        <div class="title">
          <template v-if="branch">{{ trans(branch.TitleMixin) }}</template>
          {{ trans('Structure de Données') }}
        </div>

        <div v-if="!root && itemTypes.length > 0" class="d-flex justify-content-center">

          <b-button class="btn-sm" variant="primary" @click="createRoot">
            <i class="fad fa-plus"></i>
            {{ trans('Creer la racine') }}
          </b-button>
        </div>


        <draggable :animation="200" :list="itemTypes" class="d-flex flex-wrap" filter=".action-button" ghost-class="bg-light-primary" group="structure" tag="div" @end="updateItemRanks">
          <template v-for="item in itemTypes">
            <div v-if="!item.required && item.code.toLowerCase() !== 'coverage'"
                 class="card m-3 card-xxl-stretch mb-xl-3 flex-grow-1 min-w-300px mw-500px">
              <div class="card-header border-0">
                <div>
                  <h3 class="card-title fw-bolder text-dark">
                    <i :class="item.icon + ' me-2'"></i>
                    {{ trans(item.name) }}
                  </h3>
                  {{ item.code }} ▪ {{ item.className }}
                </div>
                <div class="card-toolbar">
                  <b-dropdown ref="filter" no-caret no-flip right size="sm" style="padding:0" tag="div" toggle-class="topbar-item text-decoration-none" variant="link">
                    <template v-slot:button-content>
                      <div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                        <i class="fad fa-th-large "></i>
                      </div>
                    </template>
                    <b-dropdown-text class="p-0 b-dropdown-text" tag="div">
                      <div class="p-0">
                        <div class="d-flex row dropmenu bg-white">
                          <a v-if="!item.isRoot || hasRole('ROLE_ADMIN')" v-b-modal.modal-1
                             class="dropdown-item cursor-pointer" @click="setItem(item)">
                            {{ trans('Edit') }}
                          </a>
                          <a v-b-modal.modal-2 class="dropdown-item cursor-pointer"
                             @click="addProperty(item)">
                            {{ trans('Add_property') }}
                          </a>
                          <a v-if="!item.isRoot || hasRole('ROLE_ADMIN')" class="dropdown-item cursor-pointer"
                             @click="deleteItem(item.uuid)">
                            {{ trans('Delete') }}
                          </a>
                        </div>
                      </div>
                    </b-dropdown-text>
                  </b-dropdown>


                </div>
              </div>
              <div class="card-body pt-2 d-flex flex-column mh-400px overflow-auto">
                <draggable :animation="200" :group="item.uuid" :list="item.properties" filter=".action-button" ghost-class="bg-light-primary" tag="div" @end="updatePropertyRanks(item)">
                  <template v-for="property in item.properties">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <span class="text-gray-800 text-hover-primary fw-bolder fs-6" href="#">
                              <i v-if="property.required" class="fas fa-asterisk text-danger"></i>
                              {{ property.ranking }} - {{ trans(property.name) }}
                            </span>
                            <span class="text-muted fw-bold d-block">
                              {{ trans(property.type.label) }} ◾
                              <template v-if="property.link">
                                <i class="fad fa-link"></i>
                                {{ property.link }} ◾
                              </template>
                              <template v-if="property.type && property.type.code === 'BOOLEAN'">
                                {{ Boolean(Number(property.value)) ? trans('true') : trans('false') }}
                              </template>
                              <template v-if="property.type && property.type.code.match(/OBJECT/)">
                                {{ itemNameFromUuid(property.value) }}
                              </template>
                              <template v-else>
                                {{ trans(property.value) }}
                              </template>
                            </span>
                          </div>
                          <div v-if="!property.internal || hasRole('ROLE_ADMIN')" class="ms-5">
                            <i v-b-tooltip.hover
                               :class="property.showOnDevis ? 'text-primary' : 'text-gray-400'"
                               :title="'Afficher dans le devis'"
                               class="fad fa-ballot-check cursor-pointer mx-1"
                               @click.prevent.stop="toggleDevis(property)"></i>
                            <i v-b-tooltip.hover
                               :class="property.isAlias ? 'text-primary' : 'text-gray-400'"
                               :title="'intégré dans l\'alias'"
                               class="fad fa-eye cursor-pointer mx-1" @click.prevent.stop="toggleAlias(property)"></i>
                            <i v-b-modal.modal-2
                               class="fad fa-edit cursor-pointer mx-1" @click="editProperty(property, item)"></i>
                            <i v-b-tooltip.hover
                               :class="property.identifier ? 'text-primary' : 'text-gray-400'"
                               :title="trans('is_an_identifier')"
                               class="fad fa-crosshairs cursor-pointer mx-1" @click.prevent.stop="toggleIdentifier(property)"></i>
                            <i class="fad fa-trash text-danger ms-2 cursor-pointer"
                               @click="removeProperty(property)"></i>
                            <!--                                            <i :class=" property.required ? 'text-danger'  : 'text-gray-400'"-->
                            <!--                                               :title="trans('is_required')" @click.prevent.stop="toggleRequired(property)"-->
                            <!--                                               class="fad fa-exclamation-triangle ms-2  cursor-pointer"-->
                            <!--                                               v-b-tooltip.hover></i>-->
                          </div>
                          <div v-else>
                            <i class="fad fa-lock text-danger"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>
              <div v-if="item.branch" class="card-footer justify-content-center py-2 d-flex">

                <div class="signature">
                  <div v-if="item.updateBy" class="user text-primary cursor-pointer">
                    {{ item.updateBy }}
                  </div>
                  <div class="date">
                    {{ readableDate(item.updatedAt) }}
                  </div>

                </div>
                <!--                            <div class="btn btn-primary btn-sm">-->
                <!--                                <i class="fad fa-plus"></i>-->
                <!--                                {{trans('Add_property')}}-->
                <!--                            </div>-->
              </div>
            </div>
          </template>
        </draggable>


        <div class="title">
          <template v-if="branch">{{ trans(branch.TitleMixin) }}</template>
          {{ trans('Schéma de Données') }}
        </div>

        <div class="card">
          <div class="card-body">
            <ItemTypeTree v-if="root" :itemType="root"/>
          </div>
        </div>
      </div>
      <b-modal id="modal-1" ref="item-modal" :title="trans('Editer un Objet')" centered size="lg">
        <form v-if="item" class="mh-500px overflow-auto">
          <b-tabs>
            <b-tab>
              <template #title>
                Configuration
              </template>
              <template #default>
                <div class="title w-100 d-flex justify-content-between">
                  <div>
                    Configuration
                  </div>
                  <div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FileUpload v-model="item.photo"
                                previewClass=" overflow-hidden cursor-pointer w-100px h-100px d-flex align-items-center justify-content-center shadow-xs
                         rounded-circle overflow-hidden "/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto m-2 flex-grow-1">
                    <label :for="'name'" class="required form-label">{{ trans('Icon') }}</label>
                    <div>
                      <IconSelector :selected="item.icon" v-on:select="item.icon = $event"></IconSelector>
                    </div>
                  </div>
                  <div class="col-auto m-2 flex-grow-1">
                    <label :for="'name'" class="required form-label">{{ trans('Name') }}</label>
                    <b-form-input :id="'name'" v-model="item.name" :state="item.name.trim().length > 0">
                    </b-form-input>
                  </div>
                  <div class="col-auto m-2 flex-grow-1">
                    <label :for="'type'" class="required form-label">{{ trans('Type') }}</label>
                    <b-form-select v-model="item.className" :state="!empty(item.className)"
                                   class="form-control  form-select">
                      <b-form-select-option value="">{{ trans('Select_a_type') }}
                      </b-form-select-option>
                      <b-form-select-option v-for="object, key in objects" :key="'object-' + key"
                                            :value="object.class">
                        {{ trans(object.name) }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                  <div class="col-auto m-2 flex-grow-1">
                    <label :for="'type_multiple'" class="required form-label">{{ trans('Défini le pack') }}</label>
                    <div>
                      <label class="form-check form-switch form-check-custom form-check-solid">
                        <input v-model="item.isPackApplier" class="form-check-input" type="checkbox"/>
                      </label>
                    </div>
                  </div>
                  <div class="col-auto m-2 flex-grow-1">
                    <label class="form-label">{{ trans('Alias depuis le parent') }}</label>
                    <div>
                      <label class="form-check form-switch form-check-custom form-check-solid" v-b-tooltip.hover title="Hérite l'alias affiché du parent (utile pour les assets sous un membre)">
                        <input v-model="item.aliasFromParent" class="form-check-input" type="checkbox"/>
                      </label>
                    </div>
                  </div>
                  <div class="col-auto m-2 flex-grow-1" v-if="item.className === 'Customer'">
                    <label class="form-label">{{ trans('Donner accès à') }}</label>
                    <b-form-select v-model="item.grantsAccessTo" class="form-control form-select" v-b-tooltip.hover title="Le bénéficiaire de cet objet aura aussi un accès sur l'ancêtre sélectionné dans la hiérarchie">
                      <b-form-select-option :value="null">Aucun</b-form-select-option>
                      <b-form-select-option v-for="ancestor in possibleAccessAncestors(item)" :key="'gat_' + ancestor.code" :value="ancestor.code">
                        {{ ancestor.name }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                  <div class="col-auto my-2 flex-grow-1">
                    <label :for="'type'" class="required form-label">{{
                        trans('Methode de Calcul Prime Nette')
                      }}</label>
                    <div class="d-flex">
                      <b-input-group>
                        <b-form-select v-model="item.method" :state="!helper.empty(item.method)"
                                       class="form-control  form-select">
                          <b-form-select-option :value="null">{{ trans('Select_a_type') }}
                          </b-form-select-option>
                          <b-form-select-option v-for="(method, key) in methods" :key="'method_' + method.id"
                                                :value="method">
                            {{ trans(method.label) }}
                          </b-form-select-option>
                        </b-form-select>
                        <b-input-group-append>
                          <div v-b-modal="'methodModal'"
                               class="btn btn-sm btn-icon btn-primary h-100"
                               style="border-top-left-radius: 0;border-bottom-left-radius: 0">
                            <i class="fad fa-plus"></i>
                          </div>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                </div>
              </template>
            </b-tab>
            <b-tab>
              <template #title>
                Workflows
              </template>
              <template #default>

                <div class="title w-100 d-flex justify-content-between">
                  <div>
                    Workflows
                  </div>
                  <div>
                  </div>
                </div>
                <div class="d-flex my-5 border-dashed border border-primary rounded p-5 m-5">
                  <div v-for="workflow in workflows" class="d-flex align-items-center">
                      <span class="form-check form-check-sm form-check-custom me-2 form-check-solid">
                          <input :checked="item.useWorkflow(workflow)" class="form-check-input widget-9-check" type="checkbox"
                                 @click="toggleWorkflow(workflow)"/>
                        </span>
                    <div class="ms-2">
                      {{ workflow.name }}
                    </div>
                  </div>
                </div>
                <div class="my-2 flex-grow-1">
                  <div class="d-flex">
                    <b-tabs>
                      <b-tab v-for="workflow in item.workflows" :key="helper.generateId()">
                        <template #title>
                          <div class="d-flex align-items-center">
                            <div class="ms-2">
                              {{ workflow.name }}
                            </div>
                          </div>
                        </template>
                        <template #default>
                          <WorkflowEditor v-model="workflow.rules" :item="item"/>
                        </template>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>

              </template>
            </b-tab>
            <b-tab>
              <template #title>
                Imprimables
              </template>
              <template>
                <div class="title w-100 d-flex justify-content-between">
                  <div>
                    Imprimables
                  </div>
                  <div>
                    <div class="btn btn-sm btn-icon btn-primary" @click="addPrintable">
                      <i class="fad fa-plus"></i>
                    </div>
                  </div>
                </div>
                <div class=" border-dashed p-5 mt-2 w-100">
                  <table class="table table-striped gy-2 gs-2 w-100">
                    <thead>
                    <tr>
                      <th>Activé</th>
                      <th>
                        Privée
                      </th>
                      <th>
                        icone
                      </th>
                      <th>
                        Noms
                      </th>
                      <th>
                        Template
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(printable, index) in item.printables">
                      <td>
                        <div class="form-check form-switch form-check-custom form-check-solid ">
                          <input v-model="printable.isActive" class="form-check-input h-30px w-40px" type="checkbox"
                                 value=""/>
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-switch form-check-custom form-check-solid ">
                          <input v-model="printable.isPrivate" class="form-check-input h-30px w-40px" type="checkbox"
                                 value=""/>
                        </div>
                      </td>
                      <td>
                        <IconSelector v-model="printable.icon"/>
                      </td>
                      <td>
                        <b-form-input v-model="printable.label"></b-form-input>
                      </td>
                      <td>
                        <select id="" v-model="printable.template" class="form form-control form-select" name="">
                          <option v-for="printable in printables" :value="printable">
                            {{ printable }}
                          </option>
                        </select>
                      </td>
                      <td style="vertical-align: middle">
                        <div class="d-flex align-items-center gap-2">
                          <a target="_blank" :href="coreUrl+'api/printable/debug/'+printable.uuid+'/?zone='+ $store.state.mainStore.currentTenant?.code" class="btn btn-xs btn-icon btn-primary">
                            <i class="fad fa-eye"></i>
                          </a>
                          <div class="btn btn-xs btn-icon btn-danger" @click="removePrintable(printable)">
                            <i class="fad fa-trash"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </b-tab>
          </b-tabs>
        </form>
        <template #modal-footer="{ ok, cancel, hide }">
          <b-button size="sm" variant="secondary" @click="cancel()">
            <i class="fad fa-times"></i>
            {{ trans('Cancel') }}
          </b-button>
          <b-button size="sm" variant="primary" @click="editItem">
            <i class="fad fa-save"></i>
            {{ trans('Save') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-2" ref="property-modal" :title="trans('Editer une propriété')" centered size="xl">
        <form v-if="property">
          <h2 class="text-gray-400">
            Code : {{ property.code }}
          </h2>
          <div class="row">
            <div v-if="property.item" class="fs-3 fw-bolder">{{ trans(property.item.name) }}</div>
            <div class="col-auto m-2 flex-grow-1">
              <label :for="'name'" class="required form-label">{{ trans('Nom') }}</label>
              <b-form-input :id="'name'" v-model="property.name" :state="!helper.empty(property.name)">
              </b-form-input>
            </div>

            <div class="col-auto m-2 flex-grow-1">
              <label :for="'name'" class="required form-label">{{ trans('Workflow') }}</label>

              <b-input-group>
                <b-form-select v-model="property.workflow" :state="!helper.empty(property.workflow)"
                               class="form-control  form-select">
                  <b-form-select-option :value="null">{{ trans('Selectionnez un workflow') }}
                  </b-form-select-option>
                  <b-form-select-option v-for="workflow in workflows" :key="'workflow_' + workflow.code"
                                        :value="workflow.code">
                    {{ trans(workflow.name) }}
                  </b-form-select-option>
                </b-form-select>
              </b-input-group>
            </div>

            <div class="col-auto m-2 flex-grow-1">
              <label :for="'name'"
                     class="required form-label">{{ trans('Obligatoire ?') }}</label>
              <BooleanInput v-model="property.required"/>
            </div>

            <div class="col-auto m-2 flex-grow-1">
              <label :for="'name'"
                     class="required form-label">{{ trans('Propriété interne (système)') }}</label>
              <BooleanInput v-model="property.internal"/>
            </div>

            <div class="col-auto m-2 flex-grow-1">
              <label :for="'name'"
                     class="required form-label">{{ trans('Reinitialiser à chaque nouvel avenant ?') }}</label>
              <BooleanInput v-model="property.resetForEachAvenant"/>
            </div>

            <div v-if="property.item && property.item.className && !property.item.className.match(/Asset|OBJECT/)"
                 class="col-auto m-2 flex-grow-1">
              <label :for="'name'" class="required form-label">{{ trans('Lien') }} {{ property.link }}</label>
              <b-form-select v-model="property.link"
                             :state="!helper.empty(property.code)" class="form-control form-select-solid form-select">
                <b-form-select-option :value="null">Selectionnez un lien</b-form-select-option>
                <b-form-select-option v-for="prop, key in classProperties" :key="key" :value="prop.name">
                  {{ trans(prop.name) }}
                </b-form-select-option>
              </b-form-select>
            </div>

            <template v-if="property.type && property.type.format.match(/NUMBER/)">
              <div class="col-auto m-2 flex-grow-1">
                <div class="d-flex align-items-center justify-content-between gap-5">
                  <label :for="'value'" class="form-label">{{ trans('Minimum') }}</label>
                  <div class="form-check form-switch form-switch-sm form-check-custom form-check-solid fw-bolder">
                    <input :checked="property.min !== null" class="form-check-input " type="checkbox" @change="property.min = $event.target.checked ? 0 : null"/>
                  </div>
                </div>
                <div>
                  <input v-model="property.min" :disabled="property.min === null" class="form-control" type="text">
                </div>
              </div>
              <div class="col-auto m-2 flex-grow-1">
                <div class="d-flex align-items-center justify-content-between gap-5">
                  <label :for="'value'" class="form-label">{{ trans('Maximum') }}</label>
                  <div class="form-check form-switch form-switch-sm form-check-custom form-check-solid fw-bolder">
                    <input :checked="property.max !== null" class="form-check-input " type="checkbox" @change="property.max = $event.target.checked ? 0 : null"/>
                  </div>
                </div>
                <div>
                  <input v-model="property.max" :disabled="property.max === null" class="form-control" type="text">
                </div>
              </div>
            </template>

            <div class="col-auto m-2 flex-grow-1">
              <label :for="'code'" class="required form-label">{{ trans('Type') }}</label>
              <b-form-select v-model="property.type" :state="!helper.empty(property.type)"
                             class="form-control form-select-solid form-select" @change="typeChanged">
                <b-form-select-option :value="null">Selectionnez un type</b-form-select-option>
                <b-form-select-option v-for="type, key in dataTypes" :key="key" :value="type">
                  {{ trans(type.label) }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <div v-if="property.type && property.type.code.match(/RADIO|CHECKBOX|PACK_CATEGORY/)"
                 class="col-auto m-2 flex-grow-1">
              <label :for="'value'" class="form-label">{{ trans('Valeur par defaut') }}</label>
              <select v-model="property.value" class="form-control form-select">
                <option>
                  Selectionnez une valeur par default
                </option>
                <option v-for="choice in property.choices" :value="choice.code">
                  {{ choice.label }}
                </option>
              </select>
            </div>


            <div v-if="property.type && property.type.code.match(/BOOLEAN/)" class="col-auto m-2 flex-grow-1">
              <label :for="'value'" class="form-label">{{ trans('Valeur par defaut') }}</label>
              <select v-model="property.value" class="form-control form-select">
                <option :value="null">
                  Selectionnez une valeur par default
                </option>
                <option value="true">
                  Oui / Vrai
                </option>
                <option value="false">
                  Non / Faux
                </option>
              </select>
            </div>

            <div v-if="property.type && property.type.code.match(/RADIO|CHECKBOX|PACK_CATEGORY/)"
                 class="col-auto m-2 flex-grow-1 w-100">
              <div class="d-flex justify-content-between mb-2">
                <label :for="'code'" class="required fw-bolder form-label">{{ trans('Choix') }}</label>
                <div>
                  <div class="btn btn-icon btn-primary btn-xs" @click="addChoice">
                    <i class="fad fa-plus"></i>
                  </div>
                  <div class="btn btn-icon btn-warning ms-2 btn-xs" @click="importFromQuestion">
                    <i class="fad fa-download"></i>
                  </div>
                </div>
              </div>
              <div class="p-5 border-dashed d-flex flex-wrap">
                <div v-for="choice in property.choices"
                     class="d-flex flex-column m-1 flex-wrap flex-grow-1 bg-light-primary p-5">
                  <div>
                    Code
                  </div>
                  <div>
                                    <textarea v-model="choice.code" class="form-control w-100"
                                              style="border:1px gray dashed;outline: none;font-size:.8em"></textarea>
                  </div>
                  <div>
                    Label
                  </div>
                  <div>
                                    <textarea v-model="choice.label" class="form-control"
                                              style="border:1px gray dashed;outline: none;"/>
                  </div>
                  <!-- <div class="d-flex flex-grow-1"> -->

                  <!-- <b-input-group-append> -->
                  <div class="btn btn-sm mt-5 btn-danger rounded"
                       @click="removeChoice(choice)">
                    <i class="fad fa-trash"></i>
                    Supprimer
                  </div>
                  <!-- </b-input-group-append> -->
                  <!-- </div> -->
                </div>
              </div>
            </div>
            <div class="col-auto m-2 flex-grow-1 w-100">
              <div class="d-flex justify-content-between mb-2">
                <label :for="'code'" class=" fw-bolder form-label">
                  {{ trans('Conditions d\'affichage') }}
                </label>
                <div>
                  <div class="btn btn-icon btn-primary btn-xs" @click="addconditionGroup(property)">
                    <i class="fad fa-plus"></i>
                  </div>

                </div>
              </div>
              <div class="p-5 border-dashed flex-wrap">

                <div v-for="group, index in property.conditionGroups" :key="'g_' + helper.generateId()"
                     class="border-dashed bg-light-success p-5">
                  <div>
                    <i class="fad fa-times"></i>
                  </div>
                  <div class="d-flex flex-wrap">
                    <div v-for="condition, cindex in group.conditions" :key="'c_' + cindex"
                         class="d-flex align-items-center">
                      <div v-if="cindex > 0" class="btn btn-success btn-sm mx-2">
                        ET
                      </div>
                      <div class="bg-secondary rounded p-1">

                        <div :set="items = getConditionAuthorizedItems(property)"
                             class="d-flex align-items-center">
                          <b-dropdown left no-caret no-flip size="sm" tag="div"
                                      toggle-class="topbar-item text-decoration-none p-0" variant="link">
                            <template v-slot:button-content>
                              <div class="btn btn-sm btn-clean btn-dropdown btn-primary">
                                <template v-if="!condition.testingProperty">
                                  {{ trans('Propriété') }}
                                </template>
                                <template v-else>
                                  {{ condition.testingProperty.name }}
                                </template>
                              </div>
                            </template>
                            <template #default="{ hide }">
                              <b-dropdown-text class="p-0 min-w-300px" tag="div">
                                <div class="row g-0 overflow-auto mh-325px px-5">
                                  <template v-for="type in items">
                                    <div>
                                      <ItemTypeClickInspector :allowSub="true"
                                                              :type="type"
                                                              @setProperty="setConditionProperty(condition, $event); hide()">
                                      </ItemTypeClickInspector>
                                    </div>
                                  </template>
                                </div>
                              </b-dropdown-text>
                            </template>
                          </b-dropdown>
                          <b-dropdown :disabled="!condition.testingProperty" no-caret no-flip
                                      right size="sm" tag="div"
                                      toggle-class="topbar-item text-decoration-none p-0" variant="link">
                            <template v-slot:button-content>
                              <div
                                  class="btn btn-sm btn-clean btn-dropdown btn-primary  mx-1">
                                <template v-if="!helper.empty(condition.operator)">
                                  {{ condition.operator }}
                                </template>
                                <template v-else>
                                  Opérateur
                                </template>
                              </div>
                            </template>
                            <template v-for="operator in operators">
                              <b-dropdown-item
                                  v-if="!operator.numeric || (operator.numeric && condition.testingProperty && condition.testingProperty.type.format === 'NUMBER')"
                                  class="whitespace-no-wrap" tag="div"
                                  @click="setOperator(condition, operator.symbol)">
                                {{ operator.name }}
                              </b-dropdown-item>
                            </template>
                          </b-dropdown>
                          <template v-if="condition.testingProperty">
                            <b-dropdown v-if="condition.testingProperty.type.code.match(/RADIO|CHECKBOX/)" no-caret no-flip right size="sm"
                                        tag="div"
                                        toggle-class="topbar-item text-decoration-none p-0"
                                        variant="link">
                              <template v-slot:button-content>
                                <div
                                    class="btn btn-sm btn-clean btn-dropdown btn-primary  mx-1">
                                  <template v-if="!helper.empty(condition.value)">
                                    {{ condition.value }}
                                  </template>
                                  <template v-else>
                                    Opérande
                                  </template>
                                </div>
                              </template>
                              <b-dropdown-item v-for="choice in condition.testingProperty.choices"
                                               :key="choice.id" class="whitespace-no-wrap" tag="div"
                                               @click="setValue(condition, choice.code)">
                                {{ choice.label }}
                              </b-dropdown-item>
                            </b-dropdown>

                            <b-dropdown v-else-if="condition.testingProperty.type.code.match(/BOOLEAN/)" no-caret no-flip right size="sm"
                                        tag="div"
                                        toggle-class="topbar-item text-decoration-none p-0"
                                        variant="link">
                              <template v-slot:button-content>
                                <div
                                    class="btn btn-sm btn-clean btn-dropdown btn-primary  mx-1">
                                  <template v-if="!helper.empty(condition.value)">
                                    {{ condition.value ? 'Oui' : 'Non' }}
                                  </template>
                                  <template v-else>
                                    Opérande
                                  </template>
                                </div>
                              </template>
                              <b-dropdown-item class="whitespace-no-wrap"
                                               tag="div" @click="setValue(condition, true)">
                                Oui/Vrai
                              </b-dropdown-item>
                              <b-dropdown-item class="whitespace-no-wrap"
                                               tag="div" @click="setValue(condition, false)">
                                Non/Faux
                              </b-dropdown-item>
                            </b-dropdown>

                            <b-form-input v-else-if="condition.testingProperty.type.format.match(/NUMBER/)" v-model="condition.value"
                                          class="w-100px"
                                          type="number"></b-form-input>

                            <b-form-input v-else-if="condition.testingProperty.type.format.match(/TEXT/)" v-model="condition.value"
                                          class="w-100px"
                                          type="text"></b-form-input>

                          </template>
                          <template v-else>
                            <button class="btn btn-sm btn-primary" disabled>
                              Valeur
                            </button>
                          </template>

                          <div>
                            <div class="btn btn-sm btn-danger btn-icon ms-2"
                                 @click="removeCondition(group, condition.genId)">
                              <i class="fad fa-trash"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mt-5 justify-content-center">
                                    <span class="btn btn-icon btn-xs btn-success fs-8" @click="addCondition(group)">
                                        <!-- <i class="fad fa-plus"></i> -->
                                        ET
                                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="property.type && property.type.format === 'NUMBER'" class="col-auto m-2 flex-grow-1">
              <label :for="'value'" class="form-label">{{ trans('Valeur par defaut') }}</label>
              <b-form-input v-model="property.value"></b-form-input>
            </div>
            <div v-if="property.type && property.type.code === 'DATE'" class="col-auto m-2 flex-grow-1">
              <label :for="'value'" class="form-label">{{ trans('Default_Value') }}</label>
              <b-form-select v-model="property.value" :state="property.value !== null && property.value !== undefined &&
                        property.value.trim().length > 0"
                             class="form-control form-select-solid form-select">
                <b-form-select-option :value="null">{{ trans('Select_an_object') }}</b-form-select-option>
                <b-form-select-option v-for="key, index in Object.keys(dateConstants)" :key="key"
                                      :value="key">
                  <!--                                    {{key}}-->
                  {{ trans(key) }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <template v-if="property.type && property.type.code.match(/DATE/)">
              <div class="col-auto m-2 flex-grow-1">
                <!--                <div class="d-flex align-items-center justify-content-between">-->
                <!--                  <label :for="'value'" class="form-label">{{ trans('Min') }}</label>-->
                <!--                  <div>-->
                <!--                    <div class="form-check form-switch form-check-custom form-check-solid">-->
                <!--                      <input :checked="property.min !== null" @change="toggleMin"-->
                <!--                             class="form-check-input h-20px w-30px" type="checkbox"/>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <label :for="'value'" class="form-label">{{ trans('Min') }}</label>
                <div>
                  <select v-model="property.min" class="form-control form-select">
                    <option :value="null">Selectionnez une option</option>
                    <option v-for="date in dates" :value="date.code_int">
                      {{ date.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-auto m-2 flex-grow-1">
                <div>
                  <label :for="'value'" class="form-label">{{ trans('Max') }}</label>
                </div>
                <select v-model="property.max" class="form-control form-select">
                  <option :value="null">Selectionnez une option</option>
                  <option v-for="date in dates" :value="date.code_int">
                    {{ date.name }}
                  </option>
                </select>
              </div>
            </template>
            <div v-if="property.type && property.type.code.match(/OBJECT_GROUP|OBJECT/)"
                 class="col-auto m-2 flex-grow-1">
              <label :for="'code'" class="required form-label">{{ trans('Value') }}</label>
              <b-input-group class="mt-3">
                <b-form-select v-model="property.value" :state="property.value !== null && property.value !== undefined &&
                            property.value.trim().length > 0"
                               class="form-control form-select-solid form-select">
                  <b-form-select-option :value="null">{{ trans('Select_an_object') }}
                  </b-form-select-option>
                  <b-form-select-option v-for="item, key in itemTypes" :key="key" :value="item.uuid">
                    {{ trans(item.name) }}
                  </b-form-select-option>
                </b-form-select>
                <b-input-group-append>
                  <div v-b-modal.modal-1
                       class="btn btn-icon btn-primary" style="border-top-left-radius: 0;border-bottom-left-radius: 0">
                    <i class="fad fa-plus"></i>
                  </div>
                </b-input-group-append>
              </b-input-group>
            </div>
            <template v-if="property.type && property.type.code === 'OBJECT_GROUP'">
              <div class="col-auto m-2 flex-grow-1">
                <div class="d-flex align-items-center justify-content-between">
                  <label :for="'value'" class="form-label">{{ trans('Min') }}</label>
                  <div>
                    <div class="form-check form-switch form-check-custom form-check-solid">
                      <input :checked="property.min !== null" class="form-check-input h-20px w-30px"
                             type="checkbox" @change="toggleMin"/>
                    </div>
                  </div>
                </div>
                <div>
                  <input-number v-if="property.min !== null" v-model="property.min" :min="0">
                  </input-number>
                  <input v-else class="form-control" disabled type="number">
                </div>
              </div>

              <div class="col-auto m-2 flex-grow-1">
                <div class="d-flex align-items-center justify-content-between">
                  <label :for="'value'" class="form-label">{{ trans('Max') }}</label>
                  <div>
                    <div class="form-check form-switch form-check-custom form-check-solid">
                      <input :checked="property.max !== null" class="form-check-input h-20px w-30px"
                             type="checkbox" @change="toggleMax"/>
                    </div>
                  </div>
                </div>
                <input-number v-if="property.max !== null" v-model="property.max" :min="0"></input-number>
                <input v-else class="form-control" disabled type="number">
              </div>
            </template>
          </div>
        </form>
        <template #modal-footer="{ ok, cancel, hide }">
          <b-button size="sm" variant="secondary" @click="cancel()">
            <i class="fad fa-times"></i>
            {{ trans('Cancel') }}
          </b-button>
          <b-button size="sm" variant="primary" @click="saveProperty()">
            <i class="fad fa-save"></i>
            {{ trans('Save') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal id="methodModal" ref="methodModal" :title="trans('Calcul')" centered>
        <form>
          <div class="row">
            <div class="col-auto m-2 flex-grow-1">
              <label class="required form-label">{{ trans('Nom') }}</label>
              <div>
                <b-form-input v-model="method.label" :state="!helper.empty(method.label)" class="form-control"
                              type="text">
                </b-form-input>
              </div>
            </div>
            <div class="col-auto m-2 flex-grow-1">
              <label class="form-label">{{ trans('Description') }}</label>
              <div>
                <textarea v-model="method.description" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </form>
        <template #modal-footer="{ ok, cancel, hide }">
          <b-button size="sm" variant="secondary" @click="cancel()">
            <i class="fad fa-times"></i>
            {{ trans('Cancel') }}
          </b-button>
          <b-button size="sm" variant="primary" @click="editMethod()">
            <i class="fad fa-save"></i>
            {{ trans('Save') }}
          </b-button>
        </template>
      </b-modal>

    </template>

  </Base>
</template>
<script lang="ts">
/* eslint-disabled */
import {Component, Vue} from 'vue-property-decorator';
import Base from "@/layouts/Base.vue";
import {api} from "@/services/Api";
import IconSelector from "@/components/IconSelector.vue";
import ItemType from "@/entity/ItemType";
import ConditionGroup from "@/entity/ConditionGroup";
import Loading from "@/components/Loading.vue";
import ItemProperty from "@/entity/ItemProperty";
import CONSTANTS, {DATES} from "@/Utils/constant";
import Popup from "@/entity/Popup";
import Branch from "@/entity/Branch";
import InputNumber from "@/components/InputNumber.vue";
import DataType from "@/entity/DataType";
import PropertyChoice from "@/entity/PropertyChoice";
import {helper} from "@/services/Helper";
import EngineMethod from "@/entity/EngineMethod";
import PropertyCondition from '@/entity/PropertyCondition';
import Swal from "sweetalert2";
import BooleanInput from "@/components/BooleanInput.vue";
import PrintableModel from "@/entity/PrintableModel";
import WorkflowEditor from "@/components/WorkflowEditor.vue";
import ItemTypeTree from "@/components/ItemTypeTree.vue";
import Insurer from "@/entity/Insurer";
import FileUpload from '@/components/FileUpload.vue'

@Component({
  components: {FileUpload, ItemTypeTree, WorkflowEditor, BooleanInput, InputNumber, Loading, IconSelector, Base}
})
export default class ItemTypeList extends Vue {
  [x: string]:
  /* eslint-disabled */
      any;

  dates = DATES
  operators = [
    {'name': 'Egal', 'symbol': '==', 'numeric': false},
    {'name': 'Inférieur', 'symbol': '<', 'numeric': true},
    {'name': 'Inférieur ou égal', 'symbol': '<=', 'numeric': true},
    {'name': 'Supérieur', 'symbol': '>', 'numeric': true},
    {'name': 'Supérieur ou égal', 'symbol': '>=', 'numeric': true},
    {'name': 'Différent', 'symbol': '!=', 'numeric': false},
  ]

  workflows = [
    {
      name: 'ASACI',
      code: 'asaci',
      rules: [],
      results: ['yellow', 'blue', 'green']
    }
  ]
  objects = [
    {name: 'Actif', class: 'Asset', type: 'CUSTOM_OBJECT'},
    {name: 'Bénéficiaire', class: 'Customer', type: 'PRIVATE_OBJECT'},
    {name: 'Groupe d\'objets', class: 'OBJECT_GROUP', type: 'CUSTOM_OBJECT'},
    {name: 'Objet', class: 'OBJECT', type: 'CUSTOM_OBJECT'},
    {name: 'Pack', class: 'Pack', type: 'PRIVATE_OBJECT'},
  ]
  dataTypes: DataType[] = []
  packCategoryChoices: any[] = []
  insurerChoices: any[] = []
  root: any = null
  itemTypes: ItemType[] = []
  item = new ItemType()
  property = new ItemProperty()
  branch: any = null
  loading = false
  dateConstants = CONSTANTS.dateConstants
  classProperties: any[] = []
  methods: EngineMethod[] = []
  isLoading = false
  method = new EngineMethod()
  printables: any[] = []
  tree: any = {}
  coreUrl = api.core
  treeConfig: any = {nodeWidth: 200, nodeHeight: 80, levelHeight: 100,}

  // Liste des itemtypes ancêtres potentiels pour le select grantsAccessTo
  // = tous les itemtypes de la branche sauf l'itemtype courant lui-même et les itemtypes de className=Customer
  // (un ancêtre Customer n'a pas de sens — on grant à un container)
  possibleAccessAncestors(item: ItemType): ItemType[] {
    return this.itemTypes.filter((it: ItemType) => {
      if (!it || !it.code) return false
      if (item && it.code === item.code) return false
      if (it.className === 'Customer') return false
      return true
    })
  }

  toggleWorkflow(workflow: any) {
    const index = this.item.workflows.findIndex((w: any) => {
      return w.code === workflow.code
    })
    if (index !== -1) {
      this.item.workflows.splice(index, 1)
    } else {
      this.item.workflows.push(workflow)
    }
  }

  getItemByUuid(uuid: string) {
    const it = this.$store.state.comparatorStore.itemTypes.find((i: ItemType) => {
      return i.uuid === uuid
    }) as ItemType;
    if (it && it.code.toLowerCase() === 'coverage') {
      return null
    }
    return it;
  }

  isCoverageProperty(prop: ItemProperty) {
    const it = this.$store.state.comparatorStore.itemTypes.find((i: ItemType) => {
      return i.uuid === prop.value
    }) as ItemType;
    return it;
  }

  addWorkflowData(config: any) {
    config.data.push({uuid: helper.generateId(), property: null, operator: null, value: null})
  }

  removeWorkflowData(config: any, index: number) {
    config.data.splice(index, 1)
  }

  async typeChanged() {
    // console.log(this.property.type)
    if (this.property.type.code === 'RADIO') {
      if (this.property.type.class === 'Insurer') {
        if (helper.empty(this.insurerChoices)) {
          const res = await api.get(api.core, 'insurer/list')
          if (res && res.data && res.data.insurers) {
            this.insurerChoices = []
            res.data.insurers.forEach((i: any) => {
              const occ = new PropertyChoice();
              occ.code = i.slug;
              occ.label = i.label;
              occ.icon = i.photo
              this.insurerChoices.push(occ)
            })
          }
          this.property.choices = this.insurerChoices
        }
      }
    }
    if (this.property.type.code === 'PACK_CATEGORY') {
      if (helper.empty(this.packCategoryChoices)) {
        const res = await api.get(api.core, 'pack/category/list/' + this.$route.params.slug)
        if (res && res.data && res.data.packCategories) {
          this.packCategoryChoices = []
          res.data.packCategories.forEach((pc: any) => {
            const occ = new PropertyChoice();
            occ.code = pc.slug;
            occ.label = pc.label;
            // occ.icon = i.photo
            this.packCategoryChoices.push(occ)
          })
        }
        this.property.choices = this.packCategoryChoices
      }
    }
  }

  addconditionGroup(property: ItemProperty) {
    const cg = new ConditionGroup();
    this.addCondition(cg)
    property.conditionGroups.push(cg)
    // console.log(property)

  }

  removeCondition(group: ConditionGroup, genId: string) {
    console.log(genId)
    const index = group.conditions.findIndex((c: PropertyCondition) => {
      return c.genId === genId
    })

    if (index > -1) {
      group.conditions.splice(index, 1)
    }
  }

  addCondition(group: ConditionGroup) {
    const cp = new PropertyCondition()
    group.conditions.push(cp)
  }

  getConditionAuthorizedItems(property: ItemProperty) {
    let req = this.itemTypes.filter((i: ItemType) => {
      return i.required || i.isRoot || i.id === property.item.id
    })
    req = req.sort((a: ItemType, b: ItemType) => {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    })
    return req
  }

  getConditionalProperties(property: ItemProperty) {

    let parents = this.findItemTypeParents(property.item)
    parents.push(property.item)
    // console.log(parents)
    return parents
  }

  async cleanOrphanProperties() {
    this.$store.commit('loading')
    const res = await api.get(api.core, 'item/property/clean/orphan/properties')
    this.$store.commit('stopLoading')
  }

  getRoot() {
    return this.itemTypes.find((item: ItemType) => item.isRoot)
  }

  setConditionProperty(condition: PropertyCondition, evt: any) {
    // console.log(condition)
    // console.log(evt)
    condition.testingProperty = evt.prop
    this.$forceUpdate()
  }

  setOperator(condition: PropertyCondition, operator: string) {
    condition.operator = operator
  }

  setValue(condition: PropertyCondition, value: any) {
    condition.value = value
  }

  getItemProperties(item: ItemType) {
    return item.properties
  }

  findItemTypeParents(itemType: ItemType, parents: ItemType[] = []) {
    // console.log('----------------------')
    // console.log('checking parent of ' + itemType.name)
    for (let it of this.itemTypes) {
      for (let prop of it.properties) {
        if (prop.type.code === 'OBJECT' || prop.type.code === 'OBJECT_GROUP') {
          if (prop.value === itemType.uuid) {
            // console.log('found ' + it.name)
            parents.push(it)
            this.findItemTypeParents(it, parents)
          }
        }
      }
    }
    return parents;
  }

  async toggleRequired(property: ItemProperty) {
    const popup = new Popup(this.trans('Loading'),
        this.trans('Updating_' + property.name + '_required_status'),
        'secondary', 'fad fa-cloud-upload-alt', true)
    const res = await api.get(api.core, 'toggle/model/property/required/' + property.id)
    if (res.property) {
      property.required = res.property.required
    }
    popup.hide()
  }

  importFromQuestion() {

  }

  async toggleIdentifier(property: ItemProperty) {
    const popup = new Popup(this.trans('Loading'),
        this.trans('Updating_' + property.name + '_identifier_status'),
        'secondary', 'fad fa-cloud-upload-alt', true)
    const res = await api.get(api.core, 'item/property/toggle/identifier/' + property.id)
    if (res && res.data) {
      property.identifier = res.data.property.identifier
    }
    popup.hide()
  }

  async toggleAlias(property: ItemProperty) {
    const popup = new Popup(this.trans('Loading'), this.trans('Actualisation'), 'secondary', 'fad fa-cloud-upload-alt', true)
    const res = await api.get(api.core, 'item/property/toggle/alias/' + property.id)
    if (res && res.data) {
      property.isAlias = res.data.property.isAlias
    }
    popup.hide()
  }

  async toggleDevis(property: ItemProperty) {
    const popup = new Popup(this.trans('Loading'), this.trans('Actualisation'), 'secondary', 'fad fa-cloud-upload-alt', true)
    const res = await api.get(api.core, 'item/property/toggle/devis/' + property.id)
    if (res && res.data) {
      property.showOnDevis = res.data.property.showOnDevis
    }
    popup.hide()
  }

  getPremium() {
    console.log(this.item)
  }

  toggleMin() {
    if (this.property.min !== null) {
      this.property.min = null as any
    } else {
      this.property.min = 0
    }
  }

  toggleMax() {
    if (this.property.max !== null) {
      this.property.max = null as any
    } else {
      this.property.max = 0
    }
  }

  addChoice() {
    let empty = false
    this.property.choices.forEach((c: PropertyChoice) => {
      if (helper.empty(c.label)) {
        empty = true
      }
    })
    if (!empty) {
      const occ = new PropertyChoice()
      this.property.choices.push(occ)
    }
  }

  async removeChoice(choice: PropertyChoice) {
    this.$store.commit('loading')
    const res = await api.get(api.core, 'item/property/delete/choice/' + choice.id)
    this.$store.commit('stopLoading')

    if (res && res.data && res.data.status === 'success') {
      const index = this.property.choices.findIndex((c: PropertyChoice) => {
        return c == choice
      })
      if (index !== -1) {
        this.property.choices.splice(index, 1)
      }
    }
  }

  addPrintable() {
    const occ = new PrintableModel()
    this.item.printables.push(occ)
  }

  async loadPrintableList() {
    const res = await api.get(api.core, 'item/printable/list')
    if (res && res.data && res.data.printables) {
      this.printables = res.data.printables
    }
  }

  removePrintable(printable: any) {
    const index = this.item.printables.findIndex((p: PrintableModel) => {
      return p.uuid === printable.uuid
    })
    if (index !== -1) {
      this.item.printables.splice(index, 1)
    }
  }

  createRoot() {
    this.item.isRoot = true
    this.item.name = 'Racine'
    this.item.icon = 'fad fa-ob'
    this.item.className = 'OBJECT'
    this.editItem()
  }

  itemNameFromUuid(uuid: string) {
    const item = this.itemTypes.find((item: ItemType) => {
      return item.uuid === uuid
    })
    if (item) {
      return item.name
    }
    return '-'
  }

  async saveProperty() {
    // console.log(this.property)
    // return
    const res = await api.post(api.core, 'item/property/edit', {property: this.property});
    if (res && res.data) {
      (this.$refs['property-modal'] as any).hide()
      this.property = new ItemProperty()
      this.load()
    }
  }

  editProperty(property: ItemProperty, item: ItemType) {
    // if (!property.editable) {
    //   return
    // }
    this.property = {...property} as any
    this.property.item = item;
    if (item.className && item.className !== 'Asset') {
      this.loadProperties(item.className)
    }
  }

  async loadProperties(classname: string) {
    const res = await api.get(api.core, 'item/type/property/list/' + classname)
    this.classProperties = []
    if (res && res.data && res.data.properties) {
      res.data.properties.forEach((a: any) => {
        this.classProperties.push(a)
      })
    }
  }

  addProperty(item: ItemType) {
    this.property = new ItemProperty()
    this.property.item = item;
    if (item.className) {
      this.loadProperties(item.className)
    }
  }

  async deleteItem(uuid: string) {
    if (this.$refs.hasOwnProperty('item-modal')) {
      (this.$refs['item-modal'] as any).hide();
    }
    this.$store.commit('loading')
    const res = await api.delete(api.core, 'item/type/delete/' + uuid);
    await this.load()
    this.$store.commit('stopLoading')
  }

  async removeProperty(property: ItemProperty) {

    const response = await Swal.fire({
      title: 'Attention',
      html: 'La suppression de cette propriété entrainera la suppression de toutes les valeurs des objets de ce modèle',
      timer: 10000,
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      didOpen: () => {
        // Swal.showLoading()
        // const b = Swal.getHtmlContainer().querySelector('b')
        // timerInterval = setInterval(() => {
        //     b.textContent = Swal.getTimerLeft()
        // }, 100)
      },
      willClose: () => {
        // clearInterval(timerInterval)
      }
    })
    if (response.isConfirmed) {
      this.$store.commit('loading')
      const popup = new Popup('Chargement', this.trans('Suppression de la propriété ' + property.name), 'secondary', 'fad fa-cloud-upload-alt', true)
      const res = await api.delete(api.core, 'item/property/delete/' + property.uuid);
      popup.hide()
      this.$store.commit('stopLoading')
    }
    this.load()
  }

  async updateItemRanks() {
    const popup = new Popup('', this.trans('Reorganisation en cours ...'), 'warning', 'fad fa-cogs', true)
    const ranks: any = []
    let i = 1;

    this.itemTypes.forEach((b: ItemType) => {
      if (b.required) {
        ranks.push({uuid: b.uuid, ranking: i})
        i++;
      }
    })
    this.itemTypes.forEach((b: ItemType) => {
      if (!b.required) {
        ranks.push({uuid: b.uuid, ranking: i})
        i++;
      }
    })
    const res = await api.post(api.core, 'item/type/update/ranks', {ranks})
    popup.hide()
  }

  async updatePropertyRanks(item: ItemType) {
    const popup = new Popup('', this.trans('Reorganisation en cours ...'), 'warning', 'fad fa-cogs', true)
    const ranks: any = []
    let i = 1;

    item.properties.forEach((prop: ItemProperty) => {
      ranks.push({uuid: prop.uuid, ranking: i})
      i++;

    })
    const res = await api.post(api.core, 'item/property/update/ranks', {ranks})
    popup.hide()
  }

  async mounted() {
    if (this.$route.params.slug) {
      const popup = new Popup('Chargement ...', '', 'secondary', 'fad fa-cloud-upload-alt', true)
      const res = await api.get(api.core, 'branch/get/data/' + this.$route.params.slug)
      if (res && res.data && res.data.branch) {
        this.branch = new Branch(res.data.branch)
      }
      if (!this.branch) {
        popup.hide()
        new Popup(this.trans('An_error_occurred'), this.trans('This_slug_dont_match_with_any_branch'), 'danger')
        return;
      }
      this.item.branch = this.branch

      await Promise.all([this.loadDataTypes(), this.load(), this.loadMethods()])
      popup.hide()

      this.loadPrintableList()
      // await this.loadDataTypes()
      // await this.load()
    }
    // await this.loadMethods()

  }

  async load() {
    const res = await api.get(api.core, 'item/type/list/' + this.branch.slug)
    if (res && res.data && res.data.itemTypes) {
      this.itemTypes = []
      res.data.itemTypes.forEach((itemType: any) => {
        const item = new ItemType(itemType)
        this.itemTypes.push(item)
        if (item.isRoot) {
          this.root = item
        }
      })
      this.$store.commit('comparatorStore/SET_ITEM_TYPES', this.itemTypes)
      this.$store.state.mainStore.itemTypes = this.itemTypes
      if (this.root) {
        this.tree = this.getItemTree(this.root)
        // console.log(this.tree)
      }
    }
  }

  async loadMethods() {
    let url = 'engine/method/list/branch/methods/' + this.branch.slug;
    const res = await api.get(api.core, url)
    if (res && res.data && res.data.methods) {
      this.methods = []
      res.data.methods.forEach((m: any) => {
        const occ = new EngineMethod(m)

        this.itemTypes.forEach((i: ItemType) => {
          if (i.method) {
            if (i.method.id === occ.id) {
              i.method = occ
            }
          }
        })
        this.methods.push(occ)
      })
    }
  }

  async editMethod() {
    this.$store.commit('loading')
    const method = {id: this.method.id, label: this.method.label, description: this.method.description}
    let url = 'engine/method/edit';

    const res = await api.post(api.core, url, {method})
    if (this.$refs.methodModal) {
      (this.$refs.methodModal as any).hide()
    }
    this.$store.commit('stopLoading')
    this.load()
    // this.loadPremiumDetailModels()
  }

  async loadDataTypes() {
    const pop = new Popup('Chargement des types', '', 'primary', 'fad fa-sync', true)
    const res = await api.get(api.master, 'api/get/data/types')
    if (res && res.data && res.data.types) {
      this.dataTypes = []
      res.data.types.forEach((type: DataType) => {
        this.dataTypes.push(new DataType(type))
      })
    }
    pop.hide()
  }

  getItemTree(item: ItemType, visited: Set<string> = new Set()) {
    if (visited.has(item.uuid)) {
      return {
        name: item.name + ' (ref circulaire)',
        code: item.code,
        icon: item.icon,
        className: item.className,
        props: [] as any,
        children: [] as any,
        parent: ItemType
      }
    }
    visited.add(item.uuid)
    let tree = {
      name: item.name,
      code: item.code,
      icon: item.icon,
      className: item.className,
      props: [] as any,
      children: [] as any,
      parent: ItemType
    };
    item.properties.forEach((prop: ItemProperty) => {
      tree.props.push(prop)
      if (prop.type.code === 'OBJECT') {
        const link = this.itemTypes.find((i: ItemType) => {
          return i.uuid === prop.value
        })
        if (link) {
          const t = this.getItemTree(link, new Set(visited))
          t.name = prop.name
          tree.children.push(t)
        }
      }
      if (prop.type.code === 'OBJECT_GROUP') {
        const link = this.itemTypes.find((i: ItemType) => {
          return i.uuid === prop.value
        })
        if (link) {
          const t = this.getItemTree(link, new Set(visited))
          t.name = prop.name + ' ...c'
          tree.children.push(t)
        }
      }
    })
    return tree
  }


  async generate() {
    const pop = new Popup('Génération en cours', '', 'primary', 'fad fa-cogs', true)
    const res = await api.get(api.core, 'item/type/generate/' + this.branch.slug)
    pop.hide()
    // console.log(res)
  }

  resetItem() {
    this.item = new ItemType()
    this.item.branch = this.branch
  }

  setItem(item: ItemType) {
    if (item.method) {
      const method = this.methods.find((m: EngineMethod) => {
        return m.id === item.method!.id
      })
      if (method) {
        item.method = method
      }
    }
    this.item = new ItemType({...item});
  }

  async editItem() {
    this.$store.commit('loading')
    this.item.branch = {id: this.branch.id, uuid: this.branch!.uuid} as Branch
    const res = await api.post(api.core, 'item/type/edit', {item: this.item})
    if (res.data.status === 'success') {
      this.load()
      this.resetItem();
      (this.$refs['item-modal'] as any).hide()
    }
    this.$store.commit('stopLoading')
  }
}
</script>
<style scoped>

</style>
